import { render, staticRenderFns } from "./make-primary-bank-account.component.vue?vue&type=template&id=686219e2&"
import script from "./make-primary-bank-account.component.vue?vue&type=script&lang=ts&"
export * from "./make-primary-bank-account.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports